import { Locale } from 'date-fns'
import { de, fr, it } from 'date-fns/locale'

export const getDateFnsLocale = (localeCode: string): Locale | undefined => {
  if (localeCode === 'de') {
    return de
  } else if (localeCode === 'fr') {
    return fr
  } else if (localeCode === 'it') {
    return it
  }
  return undefined
}
